import { Flash } from "~/jose_modern/flash";
import { Highlighter } from "~/jose_modern/highlighter";

export const LOT_CODE_MISSING_CLASS = "lot-code-required-missing";

const HIGHLIGHT_OPTIONS = { color: "rgba(255, 100, 100, 0.3)", duration: 2000 };

export function isLotCodeRequired() {
  return document.getElementById("lot-code-required") !== null;
}

// Marks a single lot code input as missing. Optionally highlights the containing row.
// Returns the input element (for collecting into an invalidElements array).
export function markInputMissing(input, row, { highlight = false } = {}) {
  input.classList.add(LOT_CODE_MISSING_CLASS);
  if (highlight && row) {
    Highlighter.highlight(row, HIGHLIGHT_OPTIONS);
  }
  return input;
}

// Checks a production-run-style row backed by the production-run-lot-codes editor.
// Returns the first invalid element, or null if valid.
export function markRowMissingLotCodes(row, { highlight = false } = {}) {
  const editor = row.querySelector("[data-lot-codes-editor]");
  if (!editor) return null;

  const inputs = Array.from(editor.querySelectorAll("[data-lot-code-input]"));
  if (inputs.length === 0) return null;

  if (inputs.some((input) => (input.dataset.lotCode ?? "").trim() !== "")) return null;

  if (highlight) {
    Highlighter.highlight(row, HIGHLIGHT_OPTIONS);
  }

  inputs.forEach((input) => input.classList.add(LOT_CODE_MISSING_CLASS));
  return inputs[0];
}

// Shows a flash error and scrolls to the first invalid element. Returns false.
// If no invalid elements, returns true (valid).
export function reportMissingLotCodes(invalidElements, message) {
  if (invalidElements.length === 0) return true;

  Flash.error(message);
  invalidElements[0].scrollIntoView({ behavior: "smooth", block: "center" });
  return false;
}
